import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-322103ef")

_pushScopeId("data-v-322103ef")
const _hoisted_1 = { class: "detail-ingredient-sub-item" }
const _hoisted_2 = { class: "detail-ingredient-sub-item-area" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "detail-ingredient-sub-item-tag-view" }, null, -1)
const _hoisted_4 = { class: "detail-ingredient-sub-item-text-area" }
const _hoisted_5 = { class: "detail-ingredient-sub-item-name-view" }
const _hoisted_6 = { class: "detail-ingredient-sub-item-value-view" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", { innerHTML: _ctx.description }, null, 8, ["innerHTML"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", { innerHTML: _ctx.quantity }, null, 8, ["innerHTML"])
        ])
      ])
    ])
  ]))
})